import { QueryClient } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import type { TFunction } from "i18next"
import { CampaignDetail } from "modules/campaigns/components/Detail"
import { campaignQuery } from "modules/campaigns/lib/campaignQuery"
import { Crumb } from "modules/shared/lib/breadcrumbs"
import { CampaignResponseDataSchema } from "schema"
import { z } from "zod"

function buildName(campaign: z.infer<typeof CampaignResponseDataSchema>, t: TFunction) {
  if (!campaign || !campaign.name || campaign.name.trim().length === 0) {
    return t("campaigns.untitled")
  }

  return campaign.name
}

function getCampaignName(id: string, queryClient: QueryClient, t: TFunction) {
  const campaign = queryClient.getQueryData(campaignQuery(id).queryKey)
  if (campaign) return buildName(campaign, t)

  return queryClient.fetchQuery(campaignQuery(id)).then((campaign) => buildName(campaign, t))
}

export const Route = createFileRoute("/_base/_auth/campaigns/$id")({
  component: RouteComponent,
  loader: ({ route: { fullPath }, params, context }) => {
    return new Crumb({
      fullPath,
      title: (t) => getCampaignName(params.id, context.queryClient, t),
      noPadding: true,
    })
  },
})

function RouteComponent() {
  const { id } = Route.useParams()

  return <CampaignDetail id={id} />
}
